import React from "react";
import { ThemeProvider, theme, TabsBase } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import { DateTime } from "luxon";

const newTheme = {
  ...theme,
  variants: {},
};

export default function BidsHistoryModal(props: any) {
  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div
            className={
              "absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900"
            }
          >
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className="relative border-b bg-blue-50 text-blue-500">
            <div className="px-4 lg:px-8">
              <div className="relative py-2 text-center">
                <h2 className="text-xl font-semibold tracking-tight">
                  Bids History
                </h2>
              </div>
            </div>
          </div>
          <div className="text-center overflow-hidden">
            <TabsBase
              elements={[
                {
                  title: (
                    <div className="flex items-center px-2">Correct Bids</div>
                  ),
                  content: (
                    <div className="flex flex-col" key="bids-content">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 overflow-hidden align-middle px-4 md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black max-h-80 overflow-y-scroll ring-opacity-5 md:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-300">
                              <thead className="bg-gray-50 w-full sticky top-0">
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    Index
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-sm font-semibold text-gray-900"
                                  >
                                    Bid
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-sm font-semibold text-gray-900"
                                  >
                                    Time
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white max-h-80 overflow-auto">
                                {props.correctBids
                                  .reverse()
                                  .map((bid: any, index: number) => (
                                    <tr className="" key={index}>
                                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                        {index + 1}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {bid.bidding_amount}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {bid.bid_timestamp
                                          ? `${DateTime.fromMillis(
                                              typeof bid.bid_timestamp ===
                                                "string"
                                                ? parseInt(bid.bid_timestamp)
                                                : bid.bid_timestamp
                                            )
                                              .setZone("Asia/Kolkata")
                                              .toFormat("hh:mm:ss a")} (IST)`
                                          : "00"}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                            {props.correctBids.length == 0 && (
                              <div className="w-full flex justify-center p-4">
                                No bids
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                },
                {
                  title: (
                    <div className="flex items-center px-2">
                      Your Failed Bids
                    </div>
                  ),
                  content: (
                    <div className="flex flex-col" key="wrong-bids-content">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 overflow-hidden align-middle px-4 md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black max-h-80 overflow-y-scroll ring-opacity-5 md:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-300">
                              <thead className="bg-gray-50 w-full sticky top-0">
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    Index
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-sm font-semibold text-gray-900"
                                  >
                                    Bid
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-sm font-semibold text-gray-900"
                                  >
                                    Time
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-sm font-semibold text-gray-900"
                                  >
                                    Reason
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white max-h-80 overflow-auto">
                                {props.userWrongBids
                                  .reverse()
                                  .map((bid: any, index: number) => (
                                    <tr className="" key={index}>
                                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                        {index + 1}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {bid.bidding_amount}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {bid.bid_timestamp
                                          ? `${DateTime.fromMillis(
                                              typeof bid.bid_timestamp ===
                                                "string"
                                                ? parseInt(bid.bid_timestamp)
                                                : bid.bid_timestamp
                                            )
                                              .setZone("Asia/Kolkata")
                                              .toFormat("hh:mm:ss a")} (IST)`
                                          : "00"}
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {bid.reason}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                            {props.userWrongBids.length == 0 && (
                              <div className="w-full flex justify-center p-4">
                                No Failed bids
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                },
              ]}
              tabsBaseClasses={{
                wrapperClasses: "pt-0",
                layout: "flex items-center justify-center",
                height: "h-full",
                width: "w-full min-w-fit",
                backgroundColor: "bg-white",
                padding: "px-2",
                cursor: "cursor-pointer",
                borderRadius: "",
                border: "border-2 border-gray-200",
                activeTabClasses:
                  "sticky left-0 right-0 bg-gray-50 text-blue-600 border-b-0 scale-y-125 font-bold",
                inactiveTabClasses: "border-gray-200",
              }}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
